import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
    gap: 8px;

    button {
      flex: 1;
      min-width: 120px;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 6px;

    button {
      width: 100%;
      min-width: auto;
    }
  }
`;
